import classnames from 'classnames';
import React from 'react';

import styles from './styles.scss';

function SvgComponent({ filled, ...props }: { filled?: boolean }): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 84" {...props}>
      <path fill="#F3F6FD" d="M0 0h50v59c0 13.807-11.193 25-25 25S0 72.807 0 59V0z" />
      <path
        className={filled ? styles.filled : null}
        stroke="#558EFC"
        strokeOpacity={0.5}
        strokeWidth={2}
        d="M14 55.4c0-4.4 3.5-5.4 5.5-5.4 2.5 0 4.5 2 5.5 3.5 1-1.5 3-3.5 5.5-3.5 2 0 5.5 1 5.5 5.4C36 62 25 68 25 68s-11-6-11-12.6z"
      />
    </svg>
  );
}

interface Props {
  isFavourite?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const FavouriteButton = ({ isFavourite, onClick, className }: Props): JSX.Element => {
  return (
    <button className={classnames(styles.button, className)} onClick={onClick}>
      <SvgComponent filled={isFavourite} />
    </button>
  );
};

export default FavouriteButton;
